import { cn } from '@/lib/utils'
import { useSetEnginePreset } from '@/features/editor/hooks/use-set-engine-preset'
import { EDITOR_MANUAL_URL } from '@/features/editor/lib/manual'
import type { PresetCode } from '@/features/editor/lib/preset'
import { useEditorStore } from '@/features/editor/stores/editor-store'
import { SectionCard } from './section-card'

type Mode = PresetCode

const options: { value: Mode; label: string; desc: string }[] = [
  {
    value: 'immersive',
    label: '第一人称叙事',
    desc: '',
  },
  {
    value: 'interactive',
    label: '第二人称叙事',
    desc: '',
  },
  {
    value: 'novel',
    label: '第三人称叙事',
    desc: '',
  },
]

export function PromptTemplateSection() {
  const engineId = useEditorStore((s) => s.draft.engineId)
  const mode = useEditorStore((s) => s.draft.promptTemplateMode)
  const patchDraft = useEditorStore((s) => s.patchDraft)

  const { setEnginePreset, isPending } = useSetEnginePreset()

  const onPick = async (next: Mode) => {
    if (!engineId) return
    if (isPending) return
    if (mode === next) return

    await setEnginePreset({ engineId, presetCode: next })
    patchDraft({ promptTemplateMode: next })
  }

  return (
    <SectionCard
      title='游戏模式'
      description={
        <>
          启用一种完整的系统定义，如有疑惑，请参考
          <a
            href={EDITOR_MANUAL_URL}
            target='_blank'
            rel='noreferrer'
            className='text-primary underline-offset-4 hover:underline'
          >
            “使用详解”
          </a>
          。
        </>
      }
    >
      <div className='grid gap-3 sm:grid-cols-3'>
        {options.map((opt) => {
          const active = mode === opt.value

          return (
            <button
              key={opt.value}
              type='button'
              disabled={!engineId || isPending}
              onClick={() => onPick(opt.value)}
              className={cn(
                'relative text-left',
                'rounded-xl border p-4',
                'bg-background transition',
                'hover:bg-muted/20',
                'focus-visible:ring-ring/30 focus-visible:ring-2 focus-visible:outline-none',
                'disabled:cursor-not-allowed disabled:opacity-70',
                active ? 'border-border/90 bg-muted/20' : 'border-border'
              )}
            >
              {active ? (
                <div className='text-muted-foreground absolute top-3 right-3 text-xs'>
                  已选择
                </div>
              ) : null}

              <div className='text-sm font-medium'>{opt.label}</div>
              <div className='text-muted-foreground mt-1 text-xs'>
                {opt.desc}
              </div>
            </button>
          )
        })}
      </div>
    </SectionCard>
  )
}
